import { isString } from './generics'

export const isHexColor = (arg: any) => {
  const re = /^#(?:[0-9a-fA-F]{3}){1,2}$/

  return isString(arg) && re.test(arg)
}
